import React from 'react';
import { Link } from 'react-router-dom';
import "../css/home.css"
import userProfile from "../image/userprofile.svg";
import ReactHtmlParser from "react-html-parser";
function BigArticleItem(props) {
    return (
        <div>
        <Link style={{textDecoration:"none"}} to={`/blog/${props.slug}`}>
            <div className="latestbox" >
                <div className="articleimg">
                    <img src={props.imglink}></img>
                </div>
                <div className="articletxt">
                    <h1>{props.title}</h1>
                    <h2>{props.semititle?ReactHtmlParser(props.semititle.substring(0, 100)):undefined}...</h2>
                    <div className="authorbox">
                        <div className="authorimg">
                            <img src={userProfile} alt={props.author}/>
                        </div>
                        <div className="authornameandarticledate">
                            <div className="authorname">
                                {props.author}
                            </div>
                            <div className="articledate">
                                {new Date(props.date).toLocaleDateString()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </Link>
        </div>
    );
}

export default BigArticleItem;